<template>
  <b-card>
    <app-echart-bar
      v-if="option && fftLoaded"
      :option-data="option"
    />
    <div
      v-else-if="!fftLoaded"
      class="d-flex justify-content-center align-items-center"
      style="height: 50px;"
    >
      <b-btn
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="primary"
        class="btn-icon"
        @click="fetchFFTData"
      >Load FFT Data</b-btn>
    </div>
    <div
      v-else
      class="d-flex justify-content-center align-items-center"
      style="height: 50px;"
    >
      <span class="text-muted">{{ message }}</span>
    </div>
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import AppEchartBar from '@core/components/charts/echart/AppEchartBar.vue'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { integer } from '@/@core/utils/validations/validations'

export default {
  components: {
    BCard,
    AppEchartBar,
  },
  props: {
    tripID: {
      type: integer,
      required: true,
    },
    assetID: {
      type: integer,
      required: true,
    },
  },
  data() {
    return {
      option: null,
      fftLoaded: false,
      message: '',
    }
  },
  // created() {
  //   this.fetchFFTData()
  // },
  methods: {
    fetchFFTData() {
      const d = new Date()
      const currentyear = d.getFullYear()
      this.fftLoaded = false
      store.dispatch('app-asset-log/fetchFFTData', { path: `SG/${currentyear}/${this.assetID}/${this.tripID}.parquet` })
        .then(response => {
          const { data } = response
          this.option = {
            title: {
              left: 'left',
              top: 0,
            },
            grid: {
              left: '2%',
              top: '5%',
              right: '5%',
              bottom: '15%',
            },
            xAxis: [
              {
                scale: true,
                data: data.frequency,
                name: 'Frequency (Hz)',
              },
            ],
            yAxis: [
              {
                scale: true,
                name: `Magnitude (mg),  Samples:  ${data.fftDataPoints}`,
              },
            ],
            series: [
              {
                type: 'bar',
                symbolSize: 5,
                data: data.magnitude,
              },
            ],
          }
          this.fftLoaded = true
        })
        .catch(error => {
          console.log(error)
          this.fftLoaded = true
          if (error.response && error.response.status !== 404) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error fetching fft data ',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
            this.message = 'Error fetching fft data'
          } else {
            this.message = 'No FFT data available'
          }
        })
    },
  },
}
</script>
